import axios from 'axios';
/**
 * 获取我的等级数据
 * @param 无参数
 * @returns {json}
 */
export const getColumnList = params => {
  return axios.get('/yongpai_h5/h5/ticker');
};

/**
 * 获取我的等级数据
 * @param userId
 * @returns {json}
 */
export const getMyRank = params => {
  return axios.get('/yongpai-user/api/user/level',{params : params});
};

/**
 * 获取等级表格
 * @param userId
 * @returns {json}
 */
export const getLevelRule = params => {
  return axios.get('/yongpai-user/api/user/rule');
};

/**
 * 获取今日加分项
 * @param userId
 * @returns {json}
 */
export const getScoreItems = params => {
  return axios.get('/yongpai-user/api/user/score_items',{params : params});
};





// WEBPACK FOOTER //
// ./src/api/vip/index.js